import React, { useCallback, useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { RoutePaths } from './enums';
import { gameLiveConnection, gameService } from './services';
import { LoadingContainer, SoundWatcher } from './containers';
import { GameMain } from './game';
import { popupStore } from './store/popupStore';
import { PopupTypes } from './constants/popupTypes';
import { applicationStore } from './store/applicationStore';
import { iframeService } from './services/iframeService';
import { PlatformMessagesWrapper } from './services/platformMessagesWrapper';
import { useFullScreen } from './hooks/useFullScreen';
import { isMobile } from './helpers/isMobile';
import IntroContent from './containers/GameIntro/IntroContent';

function App() {
  const lostInternetConnection = useCallback(() => {
    gameService.sendLauncherErrorCode();
  }, []);
  if (!isMobile()) useFullScreen();

  const reconnectInternet = useCallback(() => {
    gameService.socketRecursiveReconnecting();
  }, []);

  useEffect(() => {
    window.addEventListener('offline', lostInternetConnection);
    window.addEventListener('online', reconnectInternet);
    return () => {
      window.removeEventListener('offline', lostInternetConnection);
      window.removeEventListener('online', reconnectInternet);
    };
  }, [lostInternetConnection, reconnectInternet]);

  useEffect(() => {
    iframeService.sendLoadedState();
  }, []);

  useEffect(() => {
    const intervalId = setInterval(() => {
      return window.location.pathname === RoutePaths.game && gameLiveConnection.sendPing();
    }, 3000);

    return () => {
      intervalId && clearInterval(intervalId);
    };
  }, []);

  return (
    <BrowserRouter>
      <LoadingContainer>
        <>
          <PlatformMessagesWrapper />
          <GameMain />
          <IntroContent />
          <SoundWatcher />
        </>
      </LoadingContainer>
    </BrowserRouter>
  );
}

export default App;
